import React, { Component } from "react";
import axios from 'axios'
import { BASEURL } from "../Config"
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { getBookInfo } from "../modules/reducers";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { compose } from "redux";
import swal from 'sweetalert';
import { NavLink } from "react-router-dom";

class AddChapters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [{
                cname: "",
            }]
        }
    }

    componentDidMount() { }

    handleChange(e, idx) {
        let data = this.state.data;
        data[idx][e.target.name] = e.target.value;
        if (e.target.value === "") {
            data[idx]['cnameError'] = true;
        }
        this.setState({
            data
        })
    }

    handleOnAddChapter(e) {
        e.preventDefault();
        let data = this.state.data;
        data.push({
            cname: ""
        })
        this.setState({
            data
        })
    }

    handleOnDeleteChapter(e, idx) {
        e.preventDefault();
        let data = this.state.data;
        data.splice(idx, 1);
        this.setState({
            data
        })
    }

    validateData() {
        let error = false;
        let data = this.state.data;
        for (let i = 0; i < data.length; i++) {
            if (data[i].cname === "") {
                data[i].cnameError = true;
                error = true;
            }
        }
        this.setState({
            data
        })
        return error;
    }

    handleSubmit() {
        let validationError = this.validateData();
        if (validationError) {
            swal('Error in Adding Chapters', 'Fill the required fields', 'error');
        } else {
            console.log('data', this.state.data);
            let data = this.state.data;
            for (let i in data) {
                data[i].bid = this.props.book._id;
            }
            console.log('data in submit', data)
            axios.post(`${BASEURL}/api/v1/chapters/createChapters`, data)
                .then(res => {
                    if (res.status === 200) {
                        console.log('res.data', res.data);
                        swal("Success", "Chapters Added successfully", "success")
                            .then(function () {
                                window.location = "chapters";
                            })
                    }
                })
                .catch((err) => {
                    console.log(err.response.data)
                    swal('Error in Adding Chapters', err.response.data, 'error');
                    console.log('Create chapters Error', err);
                })
        }
    }

    render() {
        return (
            <div id="wrapper">
                <Sidebar act="books" />
                {/* Content Wrapper */}
                <div className="content-page">
                    {/* Main Content */}
                    <div className="content">
                        <Topbar act="Add Chapters" breadcrumbItems={['Test Generator', { label: 'Books', path: '/books' }, { label: 'Chapters', path: '/chapters' }, 'Add New Chapters']} />
                        {/* container */}
                        {/* content */}
                        <div className="container-fluid main-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card main-card">
                                        <div className="card-body">
                                            <h4 className="page-title">Book name: {this.props.book.name}</h4>
                                            {this.state.data.map((item, idx) => (
                                                <div className="row">
                                                    <div className="col-xl-6">
                                                        <div className="mb-3">
                                                            {idx === 0 ? <label htmlFor="chaptername" className="form-label">Name of the chapter</label> : ''}
                                                            <input type="text" id="chaptername" className="form-control" onChange={(e) => this.handleChange(e, idx)}
                                                                name="cname" placeholder="Enter Chapter Name"
                                                                value={item.cname} />
                                                            {item.cnameError ? <p className="errTxt">* required</p> : ''}
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-3">
                                                        {idx === 0 ? <label htmlFor="actions" className="form-label">Actions</label> : ''}
                                                        <div className="mb-3">
                                                            <button className="btn btn-danger" onClick={(e) => this.handleOnDeleteChapter(e, idx)}><i className="mdi mdi-minus-circle" /> Delete</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            <div className="mb-2">
                                                <button className="btn btn-success " onClick={(e) => this.handleOnAddChapter(e)}><i className="mdi mdi-plus-circle" /> Chapter</button>
                                            </div>
                                            <button type="submit" class="btn btn-customprimary" onClick={() => this.handleSubmit()}>Submit</button>
                                            {/* end row */}
                                        </div> {/* end card-body */}
                                    </div> {/* end card*/}
                                </div> {/* end col*/}
                            </div>
                            {/* end row*/}
                        </div>
                        {/* End of Main Content */}
                        <Footer />
                    </div>
                    {/* End of Content Wrapper */}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        book: getBookInfo(state)
    }
}

export default compose(withRouter, connect(mapStateToProps))(AddChapters);